import React, { useState } from "react";
import i18n from "../lib/i18n";
import Loader from "./Loader";
import ChartSelector from "./ChartSelector";
import TimeBarChart from "./TimeBarChart";
import { preferredEnergySavingsColors } from "../lib/chartHelpers";

const FacilitiesPageAnalysis = ({ analysis, sustainabilityEnabled }) => {
  const [activeTab, setActiveTab] = useState("by_action_type");

  if (!analysis) {
    return <Loader />;
  }

  const groupedActionTypeCosts = analysis.action_type;
  const groupedFacilityCosts = analysis.yearly_facility_costs;
  const groupedTagCosts = analysis.facility_tag_costs;

  const assignLabelAndDataToObject = (item) =>
    Object.assign({}, item, {
      label: item.name,
      data: item.costs,
    });

  const yearlyActionTypeChartData = groupedActionTypeCosts.map(
    assignLabelAndDataToObject
  );
  const yearlyChartData = groupedFacilityCosts.map(assignLabelAndDataToObject);
  const yearlyTagChartData = groupedTagCosts.map(assignLabelAndDataToObject);
  const yearlyEnergySavingsChartData = analysis.energy_savings;

  const netCostChartData = sustainabilityEnabled
    ? assignLabelAndDataToObject(analysis.net_cost_data)
    : undefined;

  const tabs = [
    {
      key: "by_action_type",
      label: i18n.t("js.components.facilities_page_analysis.by_action_type"),
      component: (
        <div data-cy="graph-organization-by-action-type">
          <TimeBarChart
            series={yearlyActionTypeChartData}
            reverseStackingOrder={true}
            lineData={netCostChartData}
          />
        </div>
      ),
    },
    {
      key: "by_facilities",
      label: i18n.t("js.components.facilities_page_analysis.by_facilities"),
      component: (
        <div data-cy="graph-organization-by-facilities">
          <TimeBarChart series={yearlyChartData} reverseStackingOrder={true} />
        </div>
      ),
    },
    {
      key: "by_tags",
      label: i18n.t("js.components.facilities_page_analysis.by_tags"),
      component: (
        <div data-cy="graph-organization-by-tags">
          <TimeBarChart stacked={false} series={yearlyTagChartData} />
        </div>
      ),
    },
    ...(sustainabilityEnabled
      ? [
          {
            key: "by_savings",
            label: i18n.t("js.components.facilities_page_analysis.by_savings"),
            component: (
              <div data-cy="graph-organization-by-savings">
                <TimeBarChart
                  series={yearlyEnergySavingsChartData}
                  preferredColors={preferredEnergySavingsColors()}
                  reverseStackingOrder={true}
                />
                <div className="info-block info-block--blue">
                  {i18n.t(
                    "js.components.facilities_page_analysis.previous_savings_info"
                  )}
                </div>
              </div>
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="flex flex-wrap gap-40 align-items-center flex-jc-spb">
        <ChartSelector
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
      <div data-cy={`graph-organization-${activeTab}`}>
        {tabs.find((tab) => tab.key === activeTab).component}
      </div>
    </>
  );
};

export default FacilitiesPageAnalysis;
